module.exports = __webpack_public_path__ + "img/member_gg.23cef865.png";